import {ChangeDetectionStrategy, Component} from '@angular/core';
import {SelectLazyComponent} from '../select-lazy/select-lazy.component';

@Component({
    selector: 'app-select-multi-category',
    templateUrl: './select-lazy-multi.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectLazyMultiComponent extends SelectLazyComponent {
}
